import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const FigmaIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#24CB71" d="M4 16a3 3 0 0 1 3-3h3v3a3 3 0 0 1-6 0" />
    <path fill="#FF7237" d="M10 1v6h3a3 3 0 0 0 0-6z" />
    <path fill="#00B6FF" d="M12.98 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
    <path fill="#FF3737" d="M4 4a3 3 0 0 0 3 3h3V1H7a3 3 0 0 0-3 3" />
    <path fill="#874FFF" d="M4 10a3 3 0 0 0 3 3h3V7H7a3 3 0 0 0-3 3" />
  </svg>
);
